import { create } from 'zustand';
import httpClient from '../../../services/http';
import { APIUtils } from '../../../utils/apiutils';

const useMedicineLayoutStore = create((set, get) => ({
    medicines: [],
    pagination: {
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
    },
    searchTerm: '',
    selectedCategory: '',
    setSearchTerm: (searchTerm) => set({ searchTerm }), //
    setSelectedCategory: (categoryId) => set({ selectedCategory: categoryId }),
    setCurrentPage: (page) =>
        set((state) => ({
            pagination: { ...state.pagination, currentPage: page },
        })),
        fetchMedicines: async (page = 1) => {
            const { searchTerm, selectedCategory } = get();
            console.log('selectedCategory>>', selectedCategory);
            console.log('searchTerm>>', searchTerm);
            // If both search and category are empty, clear state and exit
            if (!searchTerm && !selectedCategory) {
                set({
                medicines: [],
                pagination: {
                    totalItems: 0,
                    totalPages: 0,
                    currentPage: 1,
                },
                });
                return;
            }
            const res = await httpClient.get(APIUtils.getAPIEndpoint('medicine'), {
				params: {
					page,
					limit: 4,
					categoryId: selectedCategory || undefined,
					search: searchTerm || undefined
				}
			}).then(res => res.data);
            set({
              medicines: res.data,
              pagination: res.meta,
            });
        },
    // setMedicines: (newMedicines) => set({ medicines: newMedicines }),
}));
export default useMedicineLayoutStore;